import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { IApplicationState } from 'ducks/reducers';
import { selectors as operationSelectors, actions as operationActions } from 'ducks/uiOperations';
import { getFormValues, isDirty, isValid, getFormSyncErrors, reset, touch } from 'redux-form';
import { selectors as uiSelectors, actions as uiActions } from 'ducks/ui';
import { selectors as formSelectors } from 'ducks/form';
import {
    selectors as jobTemplateSelectors,
    actions as jobTemplateActions
} from 'ducks/jobTemplateMaintenance/jobTemplate';
import JobTemplateDetails from './JobTemplateDetails';

const FORM_NAME = 'JobTemplateDetails';

const mapStateToProps = (state: IApplicationState) => ({
    values: getFormValues(FORM_NAME)(state),
    isValid: isValid(FORM_NAME)(state),
    formSyncErrors: getFormSyncErrors(FORM_NAME)(state),
    operationMode: operationSelectors.operationMode(state),
    jobTemplateData: jobTemplateSelectors.jobTemplateData(state),
    selectedTab: uiSelectors.selectedTab(state),
    selectedForm: formSelectors.selected(state),
    isFormLoading: jobTemplateSelectors.isFormLoading(state),
    isBrowseLookUpOpen: uiSelectors.isBrowseLookUpOpen(state),
    selectedJobTemplate: jobTemplateSelectors.selected(state),
    dirty: isDirty(FORM_NAME)(state),
    formAsyncErrors: formSelectors.getFormAsyncErrors(FORM_NAME)(state)
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
    {
        resetForm: () => reset(FORM_NAME),
        changeConfirmationDialog: uiActions.changeConfirmationDialog,
        changeOperationMode: operationActions.changeOperationMode,
        createJobTemplate: jobTemplateActions.create,
        updateJobTemplate: jobTemplateActions.update,
        deleteJobTemplate: jobTemplateActions.delete,
        touchFormFields: (...args: any) => touch(FORM_NAME, ...args),
    },
    dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(JobTemplateDetails);
